import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { AppUtils } from "@app/shared/util/app.utils";


@Component({
    selector: 'app-display-label',
    templateUrl: './display-label.component.html',
    styleUrls: ['./display-label.component.scss']
})
export class DisplayLabelComponent {

    @Input() label: string;
    @Input() value: any;
    @Input() valuePrefix: any;
    @Input() valuePrefixBold = false;
    @Input() valueLink: any;
    @Input() valueSuffix: any;
    @Input() labelStyle: {};
    @Input() valueStyle: {};
    @Input() labelClass: {};
    @Input() valueClass: {};
    @Input() inlineLabel = false;
    @Input() hasHyperlinkValue = false;
    @Input() id = AppUtils.generateUUID();
    @HostBinding('class.stretch') @Input() stretch = false;

    @Output() onHyperlinkClick = new EventEmitter<any>();

    constructor(private translateService: TranslateService) {
    }

    private formatDisplayValue(value: any, fallback: string = 'N/A') {
        if (value === null || value === undefined || value === '') {
            return fallback;
        }

        const type = typeof (value);
        switch (type) {
            case "boolean":
                return value ? this.translateService.instant('generic.yes') :
                    this.translateService.instant('generic.no')
            default:
                return value;
        }
    }

    get displayValue() {
        return this.formatDisplayValue(this.value, 'N/A');
    }

    get displayValuePrefix() {
        return this.formatDisplayValue(this.valuePrefix, '');
    }

    get displayValueLink() {
        return this.formatDisplayValue(this.valueLink, '');
    }

    get displayValueSuffix() {
        return this.formatDisplayValue(this.valueSuffix, '');
    }

    get useSplitHyperlinkValue(): boolean {
        return this.valuePrefix !== undefined || this.valueLink !== undefined || this.valueSuffix !== undefined;
    }

    hyperlinkClick($event) {
        this.onHyperlinkClick.emit($event);
    }
}
